export class Authentication {
    loading: boolean;
    errorDescription: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/model/authentication.model.ts